import SearchIcon from "@mui/icons-material/Search";
import type { CSSProperties } from "react";
import React from "react";
import { useTranslation } from "react-i18next";

import StyledTextField from "../StyledTextField/StyledTextField";

type TProps = {
    filterValue: string;
    setFilterValue: React.Dispatch<React.SetStateAction<string>>;
    searchPlaceholder?: string;
    size?: "medium" | "small";
    /**
     * Pass this prop if you want the search-bar fit the size of our <StyledButton/> component
     */
    fitBtnSize?: boolean;
    style?: CSSProperties;
};

const FilterInput = ({
    filterValue,
    setFilterValue,
    searchPlaceholder,
    size = "medium",
    fitBtnSize = false,
    style,
}: TProps) => {
    const [t] = useTranslation();
    const handleChangeValue = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
        setFilterValue(e.target.value);

    const btnSizedStyle = {
        ".MuiInputBase-input": { fontSize: "14px !important", paddingBlock: "6px !important" },
    };

    return (
        <StyledTextField
            value={filterValue}
            onChange={handleChangeValue}
            fullWidth
            placeholder={searchPlaceholder ?? t("FilterInput.Placeholder")}
            size={size}
            sx={{
                ...style,
                ...(fitBtnSize && btnSizedStyle),
                ...(size === "small" && { ".MuiInputBase-input": { fontSize: "12px !important" } }),
            }}
            InputProps={{
                endAdornment: (
                    <SearchIcon
                        sx={{
                            color: "#A8A8A8",
                            ...(fitBtnSize && { height: "18px", width: "18px" }),
                            ...(size === "small" && { height: "16px", width: "16px" }),
                        }}
                    />
                ),
            }}
        />
    );
};

export default FilterInput;
